module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "el-menu-item",
    class: {
      'is-active': _vm.active,
      'is-disabled': _vm.disabled
    },
    style: ([_vm.paddingStyle, _vm.itemStyle, {
      backgroundColor: _vm.backgroundColor
    }]),
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    },
    on: {
      "click": _vm.handleClick,
      "mouseenter": _vm.onMouseEnter,
      "focus": _vm.onMouseEnter,
      "blur": _vm.onMouseLeave,
      "mouseleave": _vm.onMouseLeave
    }
  }, [(
    _vm.parentMenu.$options.componentName === 'ElMenu' &&
    _vm.rootMenu.collapse &&
    _vm.$slots.title
  ) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "right"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "0",
      "top": "0",
      "height": "100%",
      "width": "100%",
      "display": "inline-block",
      "box-sizing": "border-box",
      "padding": "0 20px"
    }
  }, [_vm._t("default")], 2)]) : [_vm._t("default"), _vm._v(" "), _vm._t("title")]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65d3fef9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/menu/src/menu-item.vue
// module id = 2108
// module chunks = 228